const fileInputStatus = {
  Empty: 'empty',
  Loaded: 'loaded',
  Loading: 'loading',
  Deleted: 'deleted',
};
export default fileInputStatus;
